import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class ParallaxFeature {
  constructor(element) {
    this.element = element
    this.image = this.element.querySelector('.modules-parallax-feature img')

    this.resizeTimeout = null;

    this.handleImageLoad = this.handleImageLoad.bind(this)
    this.handleResize = this.handleResize.bind(this)
  }

  calculateImageOffset() {

    const imageRect = this.image.getBoundingClientRect()
    const elementRect = this.element.getBoundingClientRect()

    // Calculate precentage of image outside of viewable area
    return parseFloat(((imageRect.height - elementRect.height) / imageRect.height).toFixed(2)) * 100
  }

  handleImageLoad() {
    this.image.removeEventListener('load', this.handleImageLoad)
    this.applyImageAnimation()
  }

  handleResize() {
    // clearTimeout(this.resizeTimeout)

    // this.element.classList.remove('disable-parallax')
    // setTimeout(() => {
    //   this.applyImageAnimation()
    // }, 250);
  }

  applyImageAnimation() {
    this.timeline.clear();
    this.image.style.transform = ''
    const offset = this.calculateImageOffset()

    this.image.style.transform = ''
    this.timeline.to(this.image, {
      y: `-${offset}%`,
      ease: "power4.out",
    })
  }

  init() {

    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.element,
        start: "top+=50% bottom",
        end: "+=300%",
        toggleActions: "play pause reverse reset",
        scrub: true,
      },
    });

    this.image.addEventListener('load', this.handleImageLoad)
    window.addEventListener('resize', this.handleResize)
  }
}

export default ParallaxFeature;
